<template>
  <div :bordered='false'>
    <div class='table-page-search-wrapper'>
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='24'>
          <a-col :md='8' :sm='12'>
            <a-form-item :label="$t(I18N_KEY.ORDER + 'curdate')">
              <a-range-picker v-model='queryParam.lendingTime' format='YYYY-MM-DD' style='width: 100%;' />
            </a-form-item>
          </a-col>
          <a-col :md='8' :sm='8'>
            <a-form-item :label="$t(I18N_KEY.ORDER + 'dateCaliber')">
              <a-select default-value='' style='width: 190px' v-model='queryParam.dateCaliber'>
                <a-select-option value='1'>
                  7天
                </a-select-option>
                <a-select-option value='2'>
                  14天
                </a-select-option>
                <a-select-option value='3'>
                  30天
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter='24'>
          <a-col :md='8' :sm='12'>
            <a-form-item :label="$t(I18N_KEY.ORDER + 'ProductType')">
              <a-select v-model='queryParam.appssidList'>
                <a-select-option v-for='item in appList' :key='item.appssid'>
                  {{ item.appName }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md='8' :sm='12'>
            <a-form-item :label="$t(I18N_KEY.ORDER + 'channelListZH')">
              <a-select default-value='' style='width: 100%' v-model='queryParam.channelList'>
                <a-select-option v-for='item in channelNameList' :value='item'>
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter='24'>
          <a-col :md='24' :sm='24'>
            <a-form-item :label="$t(I18N_KEY.ORDER + 'adgroupNameListZH')">
              <a-select style='width: 100%' v-model='queryParam.adGroupNameList'>
                <a-select-option v-for='(item, index) in adgroupNameList' :key='index' :value='item'>
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
        </a-row>
        <a-row :gutter='24'>
          <a-col :md='6' :sm='8'>
            <span style='float: left;overflow: hidden;' class='table-page-search-submitButtons'>
              <a-button type='primary' @click='searchQuery' icon='search'>{{ $t('search') }}</a-button>
              <a-button type='primary' @click='searchReset' icon='reload' style='margin-left: 8px'>{{
                  $t('reset')
                }}</a-button>
               <a-button style='margin-left: 20px' type='primary' @click='opentableModal()'>广告消耗填充</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref='table'
        size='middle'
        :columns='columns'
        :dataSource='dataSource'
        :pagination='false'
        :loading='loading'
        bordered
      >
        <a-table
          slot='expandedRowRender'
          slot-scope='text'
          ref='table'
          size='middle'
          :columns='childColumns'
          :dataSource='text.channelDetails'
          :pagination='false'
          :loading='loading'
          bordered
          v-if="text.beginDate !== 'Total'"
        >
          <a-table
            slot='expandedRowRender'
            slot-scope='text'
            ref='table'
            size='middle'
            :columns='adgroupDetails'
            :dataSource='text.adgroupDetails'
            :pagination='false'
            :loading='loading'
            bordered
            v-if="text.beginDate !== 'Total'"
          >
          </a-table>

        </a-table>
      </a-table>
      <div style='margin-top: 15px; text-align: right;'>
        <v-pagination
          v-if='total'
          :page-num='queryParam.pageNum'
          :page-size='queryParam.pageSize'
          :total='total'
          @change='handleTableChange'
        />
      </div>
    </div>
    <a-modal
      title='Title'
      :visible='tableModalvisible'
      :confirm-loading='tableModalconfirmLoading'
      @ok='tableModalhandleOk'
      @cancel='tableModalhandleCancel'
      width='700'
    >
      <!--     form表单搜索区域   -->
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='12'>
          <!--          <a-col :md='6' :sm='8'>-->
          <!--            <a-form-item label="搜索项目1">-->
          <!--              <a-input :placeholder="$t('enter')"-->
          <!--                       v-model='moadlqueryParam.searchone'></a-input>-->
          <!--            </a-form-item>-->
          <!--          </a-col>-->
          <!--          <a-col :md='6' :sm='8'>-->
          <!--            <a-form-item label="搜索项目1">-->
          <!--              <a-input :placeholder="$t('enter')"-->
          <!--                       v-model='moadlqueryParam.searchtwo'></a-input>-->
          <!--            </a-form-item>-->
          <!--          </a-col>-->
          <a-form-item :label="$t(I18N_KEY.ORDER + 'curdate')">
            <a-range-picker v-model='innerQueryParam.lendingTime' format='YYYY-MM-DD' style='width: 100%;' />
          </a-form-item>
          <a-button type='primary' @click='gettablelist()' icon='search'>{{ $t('search') }}</a-button>
        </a-row>
      </a-form>
      <!--        表格区域-->
      <a-table bordered :data-source='modalTabledataSource' :columns='modalTablecolumns'>
        <template slot='actions' slot-scope='text, record'>
          <a @click='updatemodaltable(record)'>点击更新</a>
          <!--            <editable-cell :text="text" @change="onCellChange(record.key, 'name', $event)" />-->
        </template>
      </a-table>
    </a-modal>
    <a-modal
      title='更新'
      :visible='updateModalvisible'
      :confirm-loading='updatetconfirmLoading'
      @ok='updateOk'
      @cancel='updatehandleCancel'
    >
      <!--     form表单搜索区域   -->
      <a-form layout='inline' @keyup.enter.native='searchQuery'>
        <a-row :gutter='12'>
          <a-col :md='6' :sm='8'>
            <a-form-item label='修改广告消耗费用渠道'>{{ currenclickChannelName }}
              <a-input :placeholder="$t('enter')"
                       v-model='updateCostVlue'></a-input>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
      <!--        表格区域-->

    </a-modal>
  </div>
</template>

<script>
import { filterObj } from '@/utils/util'
import {
  getmodalTbleList,
  updatemodalTbleList,
  getApplist,
  getProdcutMarketDataChannelAndAd, convertDataAdgroupNameDelivery, findProductMarketDatas
} from '@/webpublicapi/order'
import Dict from '../modules/Dict.vue'
import DictSelect from '../modules/DictSelect.vue'
import moment from 'moment'
import vModal from '../modules/Modal.vue'

const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  COLLECTION: 'collection.'
}

export default {
  name: 'ConvertDataAdgroupNameDelivery',
  components: {
    Dict,
    DictSelect,
    vModal
  },
  data() {
    return {
      columns: [],
      childColumns: [],
      adgroupDetails: [],
      updateModalvisible: false,
      updatetconfirmLoading: false,
      tableModalvisible: false,
      tableModalconfirmLoading: false,
      moadlqueryParam: {
        searchone: '',
        searchtwo: '',
      },
      updateCostVlue: '',
      currenclickid: '',
      currenclickChannelName: '',
      modalTabledataSource: [],
      modalTablecolumns: [
        {
          title: '业务id',
          dataIndex: 'id',
          width: '30%'
          // scopedSlots: { customRender: 'id' },
        },
        {
          title: '日期',
          dataIndex: 'cur_date'
        },
        {
          title: '公司',
          dataIndex: 'company_name'
        },
        {
          title: '渠道',
          dataIndex: 'channelName'
        },
        {
          title: '广告消耗',
          dataIndex: 'ad_cost'
        },
        {
          title: '更新',
          dataIndex: '',
          scopedSlots: { customRender: 'actions' }
        }


      ],


      I18N_KEY,
      toggleSearchStatus: false,
      visible: false,
      orderId: undefined,
      custInfoId: undefined,
      taskId: undefined,
      // 分页参数
      form: {
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      innerDataSource: [],
      dataSource: [],
      appList: [],
      adgroupNameList: [],
      channelNameList: [],
      deadlineConfigList: [],
      // 查询条件
      queryParam: {
        adGroupNameList: '',
        channelList: '',
        dateCaliber: '',
        deadlineConfigValue: '',
        orderNo: '',
        appssidList: '',
        mobileNo: '',
        orderType: '',
        lendingTime: [moment().add('days', -2), moment().add('days', 0)]
      },
      innerQueryParam: {
        lendingTime: []
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    innerColumns() {
      return [
        {
          title: '业务ID',
          align: 'left',
          dataIndex: 'id'
        },
        {
          title: '广告消费',
          align: 'left',
          dataIndex: 'adCost'
        }
      ]
    },
    // columns() {
    //   return [
    //     {
    //       title: this.$t('order.company'),
    //       align: 'left',
    //       dataIndex: 'companyName'
    //     },
    //     {
    //       title: this.$t('order.adCost'),
    //       align: 'left',
    //       dataIndex: 'adCost'
    //     },
    //     {
    //       title: this.$t('order.installsCount'),
    //       align: 'left',
    //       dataIndex: 'installsCount'
    //     },
    //     {
    //       title: this.$t('order.installPrice'),
    //       align: 'left',
    //       dataIndex: 'installPrice'
    //     },
    //     {
    //       title: this.$t('order.registryCount'),
    //       align: 'left',
    //       dataIndex: 'registryCount'
    //     },
    //     {
    //       title: this.$t('order.applySuccessCount'),
    //       align: 'left',
    //       dataIndex: 'applySuccessCount'
    //     },
    //     {
    //       title: this.$t('order.riskPassCount'),
    //       align: 'left',
    //       dataIndex: 'riskPassCount'
    //     },
    //     {
    //       title: this.$t('order.loanSuccessCount'),
    //       align: 'left',
    //       dataIndex: 'loanSuccessCount'
    //     },
    //     {
    //       title: this.$t('order.loanPrice'),
    //       align: 'left',
    //       dataIndex: 'loanPrice'
    //     },
    //     {
    //       title: this.$t('order.roiSeven'),
    //       align: 'left',
    //       dataIndex: 'roiSeven'
    //     }
    //     ,
    //     {
    //       title: this.$t('order.roiFourteen'),
    //       align: 'left',
    //       dataIndex: 'roiFourteen'
    //     }
    //     ,
    //     {
    //       title: this.$t('order.roiThirty'),
    //       align: 'left',
    //       dataIndex: 'roiThirty'
    //     }
    //     ,
    //     {
    //       title: this.$t('order.roiOther'),
    //       align: 'left',
    //       dataIndex: 'roiOther'
    //     }
    //   ]
    // },
    //
    // childColumns() {
    //   return [
    //     // {
    //     //   title: '日期',
    //     //   align: 'left',
    //     //   dataIndex: 'curDate'
    //     // },
    //     {
    //       title: '渠道',
    //       align: 'left',
    //       dataIndex: 'channelName'
    //     },
    //     {
    //       title: this.$t('order.adCost'),
    //       align: 'left',
    //       dataIndex: 'adCost'
    //     },
    //     {
    //       title: this.$t('order.installsCount'),
    //       align: 'left',
    //       dataIndex: 'installsCount'
    //     },
    //     {
    //       title: this.$t('order.installPrice'),
    //       align: 'left',
    //       dataIndex: 'installPrice'
    //     },
    //     {
    //       title: this.$t('order.registryCount'),
    //       align: 'left',
    //       dataIndex: 'registryCount'
    //     },
    //     {
    //       title: this.$t('order.applySuccessCount'),
    //       align: 'left',
    //       dataIndex: 'applySuccessCount'
    //     },
    //     {
    //       title: this.$t('order.riskPassCount'),
    //       align: 'left',
    //       dataIndex: 'riskPassCount'
    //     },
    //     {
    //       title: this.$t('order.loanSuccessCount'),
    //       align: 'left',
    //       dataIndex: 'loanSuccessCount'
    //     },
    //     {
    //       title: this.$t('order.loanPrice'),
    //       align: 'left',
    //       dataIndex: 'loanPrice'
    //     },
    //     {
    //       title: this.$t('order.roiSeven'),
    //       align: 'left',
    //       dataIndex: 'roiSeven'
    //     },
    //     {
    //       title: this.$t('order.roiFourteen'),
    //       align: 'left',
    //       dataIndex: 'roiFourteen'
    //     },
    //     {
    //       title: this.$t('order.roiThirty'),
    //       align: 'left',
    //       dataIndex: 'roiThirty'
    //     },
    //     {
    //       title: this.$t('order.roiOther'),
    //       align: 'left',
    //       dataIndex: 'roiOther'
    //     }
    //   ]
    // },
    // adgroupDetails() {
    //   return [
    //     // {
    //     //   title: '日期',
    //     //   align: 'left',
    //     //   dataIndex: 'curDate'
    //     // },
    //     {
    //       title: '广告组',
    //       align: 'left',
    //       dataIndex: 'adgroupName'
    //     },
    //     {
    //       title: this.$t('order.adCost'),
    //       align: 'left',
    //       dataIndex: 'adCost'
    //     },
    //     {
    //       title: this.$t('order.installsCount'),
    //       align: 'left',
    //       dataIndex: 'installsCount'
    //     },
    //     {
    //       title: this.$t('order.registryCount'),
    //       align: 'left',
    //       dataIndex: 'registryCount'
    //     },
    //     {
    //       title: this.$t('order.applySuccessCount'),
    //       align: 'left',
    //       dataIndex: 'applySuccessCount'
    //     },
    //     {
    //       title: this.$t('order.riskPassCount'),
    //       align: 'left',
    //       dataIndex: 'riskPassCount'
    //     },
    //     {
    //       title: this.$t('order.loanSuccessCount'),
    //       align: 'left',
    //       dataIndex: 'loanSuccessCount'
    //     },
    //     {
    //       title: this.$t('order.roiSeven'),
    //       align: 'left',
    //       dataIndex: 'roiSeven'
    //     }
    //     ,
    //     {
    //       title: this.$t('order.roiFourteen'),
    //       align: 'left',
    //       dataIndex: 'roiFourteen'
    //     }
    //     ,
    //     {
    //       title: this.$t('order.roiThirty'),
    //       align: 'left',
    //       dataIndex: 'roiThirty'
    //     },
    //     {
    //       title: this.$t('order.roiOther'),
    //       align: 'left',
    //       dataIndex: 'roiOther'
    //     }
    //   ]
    // }
  },
  created() {
    this.gettablelist({
      startDate: moment().add('days', -2),
      endDate: moment().add('days', 0)
    })

    getApplist().then(res => {
      this.appList = res.data || []
    })
    getProdcutMarketDataChannelAndAd().then(res => {
      this.adgroupNameList = res.data.adgroupNameList || []
      this.channelNameList = res.data.channelNameList || []
      console.log('adGroupNameList', this.adGroupNameList)
      console.log('channelNameList', this.channelNameList)
    })

    this.getDict()
    this.loadData(1)
    // getAllDeadlineConfig().then(res => {
    //   this.deadlineConfigList = res.data || []
    // })
  },
  methods: {

    gettablelist(params) {
      let paramsTemp = this.getInnerQueryParams() // 查询条件

      getmodalTbleList(paramsTemp).then(res => {
        console.log('resfskgvnbfs', res)
        this.modalTabledataSource = res.data || []
      })
    },
    updatemodaltable(value) {
      //打开弹窗
      console.log('拿到的本行数据', value)
      this.currenclickid = value.id
      this.currenclickChannelName = value.channelName
      this.updateModalvisible = true
    },
    updateOk(e) {
      this.updatetconfirmLoading = true
      if (this.updateCostVlue) {
        updatemodalTbleList({ id: this.currenclickid, ad_cost: this.updateCostVlue }).then(res => {
          console.log('修改成功了吗', res)
          if (res.code == 1000) {
            this.$message.success('修改成功')
            this.updateCostVlue = ''//清空弹窗默认值
            //关闭修改弹窗
            this.updateModalvisible = false
            //刷新表格
            this.gettablelist({
              startDate: '2024-12-20',
              endDate: '2024-12-25'
            })
          } else {
            this.$message.error(res.msg)
          }
        })
      } else {
        this.$message.error('请输入cost')
      }
      setTimeout(() => {
        this.updatetconfirmLoading = false
      }, 2000)
      //调用更新接口
    },
    updatehandleCancel(e) {
      console.log('Clicked cancel button')
      this.updateModalvisible = false
    },
    opentableModal() {
      this.tableModalvisible = true
    },
    tableModalhandleOk(e) {
      this.tableModalconfirmLoading = true
      setTimeout(() => {
        this.tableModalvisible = false
        this.tableModalconfirmLoading = false
      }, 2000)
    },
    tableModalhandleCancel(e) {
      console.log('Clicked cancel button')
      this.tableModalvisible = false
    },


    searchQuery() {
      this.loadData(1)
    },
    loadData(arg) {
      // 加载数据 若传入参数1则加载第一页的内容
      if (arg === 1) {
        this.queryParam.pageNum = 1
        this.queryParam.pageSize = 10
      }
      this.loading = true
      let params = this.getQueryParams() // 查询条件
      console.log(params)
      findProductMarketDatas(Object.assign({}, params))
        .then(res => {
          if (res.code === 1000) {
            console.log(res.data.rows)
            this.dataSource = res.data.rows || []
          } else {
            this.dataSource = []
            this.$message.error(res.msg)
          }
          this.loading = false
        })
        .catch(e => {
          this.loading = false
          this.$message.error(e.message)
        })
    },
    transformTime(time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow(str) {
      return str && str.toLocaleLowerCase()
    },
    getQueryParams() {
      //默认展示一定会显示的数据
      this.columns=[{
        title: this.$t('order.company'),
        align: 'left',
        dataIndex: 'companyName'
      },
        {
          title: this.$t('order.adCost'),
          align: 'left',
          dataIndex: 'adCost'
        },
        {
          title: this.$t('order.installsCount'),
          align: 'left',
          dataIndex: 'installsCount'
        },
        {
          title: this.$t('order.installPrice'),
          align: 'left',
          dataIndex: 'installPrice'
        },
        {
          title: this.$t('order.registryCount'),
          align: 'left',
          dataIndex: 'registryCount'
        },
        {
          title: this.$t('order.applySuccessCount'),
          align: 'left',
          dataIndex: 'applySuccessCount'
        },
        {
          title: this.$t('order.riskPassCount'),
          align: 'left',
          dataIndex: 'riskPassCount'
        },
        {
          title: this.$t('order.loanSuccessCount'),
          align: 'left',
          dataIndex: 'loanSuccessCount'
        },
        {
          title: this.$t('order.loanPrice'),
          align: 'left',
          dataIndex: 'loanPrice'
        }]
      this.childColumns=[  {
        title: '渠道',
        align: 'left',
        dataIndex: 'channelName'
      },
        {
          title: this.$t('order.adCost'),
          align: 'left',
          dataIndex: 'adCost'
        },
        {
          title: this.$t('order.installsCount'),
          align: 'left',
          dataIndex: 'installsCount'
        },
        {
          title: this.$t('order.installPrice'),
          align: 'left',
          dataIndex: 'installPrice'
        },
        {
          title: this.$t('order.registryCount'),
          align: 'left',
          dataIndex: 'registryCount'
        },
        {
          title: this.$t('order.applySuccessCount'),
          align: 'left',
          dataIndex: 'applySuccessCount'
        },
        {
          title: this.$t('order.riskPassCount'),
          align: 'left',
          dataIndex: 'riskPassCount'
        },
        {
          title: this.$t('order.loanSuccessCount'),
          align: 'left',
          dataIndex: 'loanSuccessCount'
        },
        {
          title: this.$t('order.loanPrice'),
          align: 'left',
          dataIndex: 'loanPrice'
        }]
      this.adgroupDetails=[ {
        title: '广告组',
        align: 'left',
        dataIndex: 'adgroupName'
      },
        {
          title: this.$t('order.adCost'),
          align: 'left',
          dataIndex: 'adCost'
        },
        {
          title: this.$t('order.installsCount'),
          align: 'left',
          dataIndex: 'installsCount'
        },
        {
          title: this.$t('order.registryCount'),
          align: 'left',
          dataIndex: 'registryCount'
        },
        {
          title: this.$t('order.applySuccessCount'),
          align: 'left',
          dataIndex: 'applySuccessCount'
        },
        {
          title: this.$t('order.riskPassCount'),
          align: 'left',
          dataIndex: 'riskPassCount'
        },
        {
          title: this.$t('order.loanSuccessCount'),
          align: 'left',
          dataIndex: 'loanSuccessCount'
        }]

      const { lendingTime  } = this.queryParam
      const data = {
        ...this.queryParam,
        startDate: lendingTime && lendingTime.length ? this.transformTime(lendingTime[0]) : undefined,
        endDate: lendingTime && lendingTime.length ? this.transformTime(lendingTime[1]) : undefined,
      }

      console.log('当前选择的日期范围',data)

      // 将字符串转换为 Date 对象
      const sd = new Date(data.startDate)
      const ed = new Date(data.endDate)
      // 计算日期差值（相差的天数）
      const diffTime = ed - sd // 时间差（毫秒）
      const diffDays = diffTime / (1000 * 60 * 60 * 24) // 转换为天数
      console.log('相差几天', diffDays)
      // 根据日期范围计算 ROI 列
      if (diffDays <= 6 || (isNaN(diffDays) && data.dateCaliber === '1')) {
        console.log('fan1')
        this.columns.push({
          title: this.$t('order.roiSeven'),
          align: 'left',
          dataIndex: 'roiSeven'
        });

        this.childColumns.push({
          title: this.$t('order.roiSeven'),
          align: 'left',
          dataIndex: 'roiSeven'
        });
        this.adgroupDetails.push({
          title: this.$t('order.roiSeven'),
          align: 'left',
          dataIndex: 'roiSeven'
        });

      } else if (diffDays <= 14 || (isNaN(diffDays) &&data.dateCaliber === '2')) {
        console.log('fan2')
        this.columns.push({
          title: this.$t('order.roiFourteen'),
          align: 'left',
          dataIndex: 'roiFourteen'
        });
        this.childColumns.push({
          title: this.$t('order.roiFourteen'),
          align: 'left',
          dataIndex: 'roiFourteen'
        });
        this.adgroupDetails.push({
          title: this.$t('order.roiFourteen'),
          align: 'left',
          dataIndex: 'roiFourteen'
        });
      } else if (diffDays <= 30 || (isNaN(diffDays) &&data.dateCaliber === '3')) {
        console.log('fan3')
        this.columns.push({
          title: this.$t('order.roiThirty'),
          align: 'left',
          dataIndex: 'roiThirty'
        });
        this.childColumns.push({
          title: this.$t('order.roiThirty'),
          align: 'left',
          dataIndex: 'roiThirty'
        });
        this.adgroupDetails.push({
          title: this.$t('order.roiThirty'),
          align: 'left',
          dataIndex: 'roiThirty'
        });
      }else {
        console.log('fan4' , this.dateCaliber)
        this.columns.push({
          title: this.$t('order.roiOther'),
          align: 'left',
          dataIndex: 'roiOther'
        });
        this.childColumns.push({
          title: this.$t('order.roiOther'),
          align: 'left',
          dataIndex: 'roiOther'
        });
        this.adgroupDetails.push({
          title: this.$t('order.roiOther'),
          align: 'left',
          dataIndex: 'roiOther'
        });
      }
      delete data.applyDate
      var param = Object.assign({}, data)

      return filterObj(param)
    },

    getInnerQueryParams() {
      const { lendingTime } = this.innerQueryParam
      const data = {
        ...this.innerQueryParam,
        startDate: lendingTime && lendingTime.length ? this.transformTime(lendingTime[0]) : undefined,
        endDate: lendingTime && lendingTime.length ? this.transformTime(lendingTime[1]) : undefined
      }
      delete data.applyDate
      var param = Object.assign({}, data)

      return filterObj(param)
    },
    handleTableChange(pageNum, pageSize) {
      this.queryParam.pageNum = pageNum
      this.queryParam.pageSize = pageSize
      this.loadData()
    },
    // 重置字典类型搜索框的内容
    searchReset() {
      var that = this
      that.queryParam.lendingTime = [moment().add('days', -1), moment().add('days', 0)]
      that.queryParam.adGroupNameList = ''
      that.queryParam.appssidList = ''
      that.queryParam.channelList = ''
      that.queryParam.dateCaliber = ''
      that.loadData(this.queryParam.pageNum)
    },
    changeModal(visible) {
      this.visible = visible
    },
    rowClassName(record, index) {
      var date = new Date(record.curDate)
      var day = date.getTime() / 24 / 60 / 60 / 1000 + 3
      console.log(record.curDate, date, (day % 7) + 1)

      if ((day % 7) + 1 == 7) {
        return 'table_weekendColor'
      }
      return ''
    }
  }
}
</script>
<style lang='less' scoped>
@import '~@/assets/less/common.less';
</style>
